module.exports = __webpack_public_path__ + "static/favicon-8072486abf43e659a3af69d99c73652a.ico";